var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDistributionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166992,
    y: 0.000976562,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8A7C67",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22193_80751",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 8.00098H24.167V24.001H8.16699V8.00098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22193_80751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4369 16.117H16.0511V9.73132C16.0511 9.65274 15.9868 9.58846 15.9083 9.58846H15.444C14.4978 9.58749 13.5876 9.76804 12.7133 10.1301C11.8391 10.4922 11.0678 11.008 10.3993 11.6777C10.0735 12.0026 9.78197 12.3558 9.52479 12.7374C9.26762 13.1189 9.04962 13.5217 8.87077 13.9456C8.49934 14.826 8.31006 15.7599 8.31006 16.7242C8.31006 17.6885 8.49934 18.6206 8.87077 19.5009C9.2297 20.3491 9.74399 21.1134 10.3993 21.7688C11.0547 22.4241 11.8172 22.9384 12.6672 23.2974C13.1066 23.4838 13.5602 23.6243 14.0281 23.719C14.4959 23.8138 14.9685 23.8607 15.4458 23.8599C16.392 23.8608 17.3022 23.6803 18.1764 23.3182C19.0507 22.9562 19.822 22.4403 20.4905 21.7706C21.1458 21.1152 21.6601 20.3527 22.019 19.5027C22.2054 19.0633 22.346 18.6097 22.4407 18.1419C22.5354 17.6741 22.5824 17.2015 22.5815 16.7242V16.2599C22.5797 16.1813 22.5155 16.117 22.4369 16.117ZM24.0065 15.126L23.9601 14.6224C23.8083 12.9795 23.0797 11.4295 21.9047 10.2599C21.3178 9.67343 20.6487 9.20398 19.8976 8.85156C19.1464 8.49914 18.3577 8.28465 17.5315 8.2081L17.0261 8.16168C16.9422 8.15453 16.8708 8.21882 16.8708 8.30275V15.1545C16.8708 15.2331 16.9351 15.2974 17.0136 15.2974L23.8637 15.2795C23.9476 15.2777 24.0137 15.2081 24.0065 15.126Z",
    fill: "#746042"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDistributionIcon);
export default __webpack_public_path__ + "static/media/timeDistributionIcon.7b6c2c9280dabc9947322254b52fd603.svg";
export { ForwardRef as ReactComponent };